import { Input } from '@chakra-ui/react';
import PropTypes from 'prop-types';
import { useLayoutEffect, useRef } from 'react';

import {
  cursorAfterGroupedFormat,
  formatGroupedNumber,
  sanitizeGroupedDraft,
} from './groupedNumber';

export default function GroupedAmountInput({
  value,
  onChange,
  onBlur,
  onFocus,
  width,
  pl,
  'aria-label': ariaLabel,
}) {
  const inputRef = useRef(null);
  const digitsBeforeRef = useRef(null);
  const display = formatGroupedNumber(value ?? '');

  useLayoutEffect(() => {
    const input = inputRef.current;
    const digitsBefore = digitsBeforeRef.current;
    if (!input || digitsBefore == null) return;
    const cursor = cursorAfterGroupedFormat(display, digitsBefore);
    input.setSelectionRange(cursor, cursor);
    digitsBeforeRef.current = null;
  }, [display]);

  return (
    <Input
      ref={inputRef}
      size="sm"
      w={width}
      px={2}
      pl={pl}
      inputMode="decimal"
      aria-label={ariaLabel}
      value={display}
      onFocus={onFocus}
      onBlur={onBlur}
      onChange={(event) => {
        const cursor = event.target.selectionStart ?? event.target.value.length;
        digitsBeforeRef.current = event.target.value
          .slice(0, cursor)
          .replace(/[^\d.]/g, '').length;
        onChange(sanitizeGroupedDraft(event.target.value));
      }}
    />
  );
}

GroupedAmountInput.propTypes = {
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  onChange: PropTypes.func.isRequired,
  onBlur: PropTypes.func,
  onFocus: PropTypes.func,
  width: PropTypes.string,
  pl: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  'aria-label': PropTypes.string,
};
